/*
 * @Author: 蓝欣 10884240+lan-xin-x@user.noreply.gitee.com
 * @Date: 2025-03-18 20:19:53
 * @LastEditors: 蓝欣 10884240+lan-xin-x@user.noreply.gitee.com
 * @LastEditTime: 2025-03-22 13:21:34
 * @FilePath: \my-car\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/index.css';
import router from './route';
const app = createApp(App);
app.use(router);
app.use(ElementPlus)
app.mount('#app')
